<template lang="html">
<div class="pgInner userFill" :style="'height:' + pageH + 'px;'">
    <el-scrollbar ref="pgScroller" style="height:100%;">

        <div class="pgHead">
            <span>朝企家 | 帐号注册</span>
            <el-button @click="goReturn" class="btn" size="small" type="primary">返回</el-button>
        </div>

        <div class="pgBody" :style="'height:' + (pageH-60) + 'px;'" >

          <el-steps :active="2" finish-status="success">
              <el-step title="基本信息"></el-step>
              <el-step title="完成注册"></el-step>
              <el-step title="平台审核"></el-step>
          </el-steps>


            <div class="tips">注册信息已提交，平台审核中</div>
            <div class="tipsc">审核成功后，会以短信方式通知您</div>
            <div class="tipsc">审核时间，工作日9:00-11:00，14:00-17:00</div>
        </div>

    </el-scrollbar>

</div>
</template>

<script>

export default {

    data(){
        return{

        }
    },
    methods:{

        goReturn:function(){
            this.$router.replace('login');
        }

    },

    created:function(){

    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.pgHead{
     height: 60px;
     line-height: 60px;
     padding-left: 30px;
     font-size: 16px;

     .btn{
         float: right;
         width: 80px;
         margin-right: 30px;
         margin-top: 15px;
     }
}

.seek-blcok{
     margin: 0 30px;
     background: white;
     padding: 30px;

     .ttl{
         font-size: 15px;
         font-weight:bold;
     }

     .content{
         margin-top: 20px;
     }

}

.pgBody{
    margin: 0 30px;
    padding: 30px;
    background: white;

    .tips{
        text-align: center;
        font-size: 30px;
        margin-top: 150px;
    }
    .tipsc{
        text-align: center;
        font-size: 14px;
        margin-top: 10px;
    }
    
}

.disbtn{
    pointer-events: none;
    width: 112px;
}

.userFill .el-form-item{
     display: inline-block;
}

</style>



// WEBPACK FOOTER //
// successFill.vue?2c2e82a4